import React, { useEffect, useState } from "react";
import { generateDiagram, getDiagram } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function ModuleDiagram({ moduleId, title, fallback }) {
  const [state, setState] = useState({ loading: true, dataUrl: null });

  useEffect(() => {
    let cancelled = false;
    getDiagram(moduleId)
      .then((r) => !cancelled && setState({ loading: false, dataUrl: r.data_url }))
      .catch(async () => {
        if (cancelled) return;
        // Auto-generate once (non-blocking) then fall back to stock image
        try {
          const r = await generateDiagram(moduleId);
          if (!cancelled) setState({ loading: false, dataUrl: r.data_url });
        } catch {
          if (!cancelled) setState({ loading: false, dataUrl: null });
        }
      });
    return () => {
      cancelled = true;
    };
  }, [moduleId]);

  return (
    <div
      className="relative rounded-md overflow-hidden border border-border bg-card"
      data-testid={`diagram-${moduleId}`}
    >
      <div className="aspect-[16/9] w-full relative flex items-center justify-center bg-muted">
        {state.loading && (
          <div className="flex flex-col items-center gap-2 text-muted-foreground">
            <Loader2 className="animate-spin" size={28} />
            <span className="text-xs">Loading illustration…</span>
          </div>
        )}
        {!state.loading && state.dataUrl && (
          <img
            src={state.dataUrl}
            alt={`Illustration for ${title}`}
            className="w-full h-full object-cover"
          />
        )}
        {!state.loading && !state.dataUrl && (
          <img
            src={fallback}
            alt={`Illustration for ${title}`}
            className="w-full h-full object-cover opacity-90"
          />
        )}
      </div>
    </div>
  );
}
